import angular from 'angular';
import template from './dropdown.jade';
import uiCianButton from '@cian/ui/app/components/button/index';
import uiCianArrow from '@cian/ui/app/components/arrow/index';
import uiCianInputWrapper from '@cian/ui/app/components/input-wrapper/index';
import uiCianDisableOutsideScroll from '@cian/ui/app/utils/disable-outside-scroll';
import uiCianClickOutside from '@cian/ui/app/components/click-outside/index';

import './styles.styl';

export default angular
  .module('ui.cian.dropdowncomponent', [uiCianButton, uiCianArrow, uiCianInputWrapper, uiCianDisableOutsideScroll, uiCianClickOutside])
  .directive('cianUiDropdownComponent', ['$sce', '$timeout', ($sce, $timeout) => ({
    scope: {},
    bindToController: {
      items: '=',
      defaultValue: '=',
      valueKey: '@?',
      textKey: '@?',
      customClass: '&?', // функция обработчик custom class
      titleKey: '@?',
      trackKey: '@?',
      title: '@?',
      cuiInvalid: '=',
      cuiRequired: '=',
      type: '@?',
      align: '@?',
      disabled: '@?'
    },
    require: ['ngModel', 'cianUiDropdownComponent'],
    link(scope, elem, attrs, [ngModelCtrl, cianUiDropdownCtrl]) {
      ngModelCtrl.tryToSetValue = value => ngModelCtrl.$setViewValue(cianUiDropdownCtrl.getItemByValue(value));

      ngModelCtrl.$parsers.push(viewValue => {
        const valueItem = angular.isObject(viewValue) ? viewValue : cianUiDropdownCtrl.getItemByValue(viewValue);
        const value = valueItem[cianUiDropdownCtrl.valueKey];
        if (value === undefined) {
          $timeout(() => {
            ngModelCtrl.$setValidity('parse', true);
          }, 0);
        }
        return value;
      });

      ngModelCtrl.$formatters.push(modelValue => {
        return cianUiDropdownCtrl.getItemByValue(modelValue)
      });

      ngModelCtrl.$isEmpty = viewValue => {
        return angular.isObject(viewValue) && viewValue === cianUiDropdownCtrl.undefinedItem;
      };

      cianUiDropdownCtrl.selectItem = item => {
        ngModelCtrl.$setViewValue(item);
        cianUiDropdownCtrl.close();
      };

      scope.$watch(() => cianUiDropdownCtrl.items, items => {
        if (items !== undefined && items.length > 0) {
          cianUiDropdownCtrl.selectItemByValue(ngModelCtrl.$modelValue);
          cianUiDropdownCtrl.isDisabled = cianUiDropdownCtrl.disabled;
        } else {
          cianUiDropdownCtrl.isDisabled = 'true';
        }
      });

      scope.$watch(() => ngModelCtrl.$viewValue, (viewValue, oldViewValue) => {
        cianUiDropdownCtrl.activeItem = viewValue;
      });

      let initialized = false;
      scope.$watch(() => cianUiDropdownCtrl.opened, (isOpen) => {
        if (initialized && !isOpen) {
          ngModelCtrl.$setTouched();
        }
        initialized = true;
      });

      scope.getClass = function (item) {
        if (scope.dropdown.customClass) {
          return scope.dropdown.customClass({
            $item: item
          });
        }
      };

      scope.getDropdownDataMark = function () {
        if (attrs.mark) {
          return attrs.mark + '|options';
        }
        return '';
      };

      attrs.$observe('disabled', disabled => {
        cianUiDropdownCtrl.isDisabled = disabled;
      });
    },
    controller: [function () {
      this.type = this.type || 'button';
      this.valueKey = this.valueKey || 'value';
      this.trackKey = 'trackBy'; // если нет в объекте, будет использоваться $indexf
      this.textKey = this.textKey || 'text';
      this.titleKey = this.titleKey || 'title';
      this.customClass = this.customClass || null;
      this.undefinedItem = {
        [this.titleKey]: this.title || 'Не выбрано',
        [this.valueKey]: undefined
      };
      this.opened = false;

      this.typeIsButton = () => this.type === 'button';

      this.isActiveItem = item => this.activeItem[this.valueKey] === item[this.valueKey];

      this.isDisabledItem = item => item.disabled === true;

      const findItemByValue = value => {
        const item = this.items.find(item => item[this.valueKey] === value);
        if (angular.isObject(item)) {
          return {...item};
        } else {
          return item;
        }
      };

      this.getItemByValue = value => {
        let item;
        if (angular.isArray(this.items) && this.items.length > 0) {
          item = findItemByValue(value);

          if (angular.isUndefined(item)) {
            item = findItemByValue(this.defaultValue);
          }

          if (angular.isUndefined(item)) {
            item = this.undefinedItem;
          }
        }
        else {
          item = this.undefinedItem;
        }
        return item;
      };

      this.selectItemByValue = value => angular.isFunction(this.selectItem) && this.selectItem(this.getItemByValue(value));

      this.getItemTitle = (item=this.undefinedItem) => {
        return $sce.trustAsHtml(String(item[this.titleKey] || item[this.textKey]));
      };

      this.getItemText = (item=this.undefinedItem) => {
        return $sce.trustAsHtml(String(item[this.textKey] || item[this.titleKey]));
      };

      this.getTitle = item => {
        const titleItem = angular.isObject(item) ? item : this.undefinedItem;
        const titleText = String(titleItem[this.titleKey] || titleItem[this.textKey]);
        return $sce.trustAsHtml(titleText);
      };

      this.tracker = (item, $index) => item[this.trackKey] || $index;

      this.opened = false;
      this.open = () => this.opened = true;
      this.close = () => this.opened = false;
      this.toggle = () => this.opened = !this.opened;
    }],
    controllerAs: 'dropdown',
    replace: true,
    template
  })])
  .name;
